<template>
  <div class="item">
    <div class="item-header">
      <div class="item-header-title">OUR ADVANTAGE</div>
      <div class="item-header-name">
        <span class="item-header-name-line" />
        <span>我们的</span>
        <span class="bold">优势</span>
        <span class="item-header-name-line" />
      </div>
      <div class="item-header-desc">已服务200+医疗数据中心建设案例、100+大中型企业数据中心建设案例、100+其他行业数据中心建设案例</div>
    </div>

    <div class="item-content">
      <Img :src="IMG" />
      <!-- <div class="advantage">
        <div>
          <div class="image img1" />
          <span>技术人员占比60%，服务先行</span>
        </div>
        <div>
          <div class="image img2" />
          <span>核心技术团队拥有15年+行业经验</span>
        </div>
        <div>
          <div class="image img3" />
          <span>具备全专业的技术服务团队</span>
        </div>
        <div>
          <div class="image img4" />
          <span>400+数据中心建设案例</span>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import IMG from '../../assets/images/home/our.png'

export default {
  data () {
    return {
      IMG
    }
  }
}
</script>

<style lang="less" scoped>
.item-content {
  width: 100%;
  margin-top: 40px!important;
}
.advantage {
  display: flex;
  justify-content: space-around;
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .image {
      width: 158px;
      height: 158px;
    }

    .img1 {
      background: url('../../assets/images/about/87.png');
      background-size: 100% 100%;
    }

    .img1:hover {
      background: url('../../assets/images/about/87_active.png');
      background-size: 100% 100%;
    }

    .img2 {
      background: url('../../assets/images/about/88.png');
      background-size: 100% 100%;
    }

    .img2:hover {
      background: url('../../assets/images/about/88_active.png');
      background-size: 100% 100%;
    }

    .img3 {
      background: url('../../assets/images/about/89.png');
      background-size: 100% 100%;
    }

    .img3:hover {
      background: url('../../assets/images/about/89_active.png');
      background-size: 100% 100%;
    }

    .img4 {
      background: url('../../assets/images/about/90.png');
      background-size: 100% 100%;
    }

    .img4:hover {
      background: url('../../assets/images/about/90_active.png');
      background-size: 100% 100%;
    }


    span {
      padding: 16px 0px;
    }
  }
}

img {
    width: 960px;
    display: inline-block;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 1120px;
    }
          
    @media screen and (min-width: 1920px){
      width: 1760px;
    }
  }
</style>